import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'

export default () => {
  router.addRoute({
    path: '/insurance',
    name: 'insurance',
    components: {
      default: () => import('./InsurancePage.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    },
    meta: {
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    }
  })
  router.addRoute({
    path: '/insurance/:insurancePartner',
    name: 'insurance-details',
    component: () => import('./insurance-details.vue'),
    meta: {
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    }
  })
}
